import { loginADS } from "./loginADS";
import { vipDonation } from "./vipDonation";

/**
 * API call methods:
 *      loginADS - basic login endpoint for existing use WestKowloon users
 *      vipDonation - verify / get user details using donationId/accessKey for prefilling info
 */
const Auth = {
    loginADS,
    vipDonation,
};

export default Auth;